import { IAuthRepository } from '../../domain/repositories/IAuthRepository';

/**
 * Logout Use Case
 * Handles user logout
 */
export class LogoutUseCase {
  constructor(private readonly authRepository: IAuthRepository) {}

  async execute(): Promise<void> {
    await this.authRepository.logout();
  }
}
